export function useRewardAnalyticsContext() {
  const authContext = useState("reward-analytics-auth-context", () => null);

  function setAuthContext({ from = "", triggerType = "click" } = {}) {
    authContext.value = from
      ? {
          from: String(from),
          trigger_type: triggerType === "pop" ? "pop" : "click",
        }
      : null;
  }

  function clearAuthContext() {
    authContext.value = null;
  }

  return { authContext, setAuthContext, clearAuthContext };
}
